<template>
    <div>
        <input type="checkbox" v-model="selected" @change="onCheckChange">
    </div>
</template>

<script>

export default {
    props: {
        eventBus: {
            type: Object,
        },
        columnIndex: {
            Type: Number
        },
        columnIdentify: {
            Type: String
        },
        config: {
            Type: Object
        },
        parentIndex: {
            Type: Number
        },
    },
    data() {
        return {
            selected: false,
            selectedRows: [],
            excludedRows: [],
        };
    },
    mounted() {
        this.$root.$once('CustomModule:ready', (customModuleEventName, moduleIndex) => {
            this.moduleIndex = moduleIndex;
            this.events.push('CustomModule:ready');
            this.events.push(customModuleEventName);

            this.$root.$on(customModuleEventName, (moduleConfig, state) => {
                this.resetState();
            });
        });
        this.mountEvents();
    },
    methods: {
        addSelectedRow(row, identityField) {
            if (this.checkSelectedRowExists(row, identityField)) {
                return;
            }

            this.selectedRows.push(row);
            this.emitStateSelectedRow();
        },
        addExcludedRow(row, identityField) {
            if (this.checkExcludedRowExists(row, identityField)) {
                return;
            }

            this.excludedRows.push(row);
            this.emitStateSelectedRow();
        },
        checkSelectedRowExists(row, identityField) {
            let searchValue = row[identityField];
            let result = this.selectedRows.filter(r => r[identityField] === searchValue);

            return result.length > 0;
        },
        checkExcludedRowExists(row, identityField) {
            let searchValue = row[identityField];
            let result = this.excludedRows.filter(r => r[identityField] === searchValue);

            return result.length > 0;
        },
        componentIndex() {
            return this.config['index'];
        },
        checkRowIsSelected(row, identityField) {
            let eventName = `${this.componentIndex()}:setRowSelected`;

            if (this.selected) {
                let rowExists = this.checkExcludedRowExists(row, identityField);
                this.eventBus.$emit(eventName, !rowExists, row);

                return;
            }

            let rowExists = this.checkSelectedRowExists(row, identityField);
            this.eventBus.$emit(eventName, rowExists, row);
        },
        defaultBindEvents() {
            let childrenComponentIndex = this.config['childrenComponentIndex'] || [];
            let bindEvents = ['rowSelected', 'rowDeselected', 'checkRowIsSelected'];
            let res = [];

            bindEvents.forEach(v => {
                childrenComponentIndex.forEach(c => {
                    res.push({
                        name: v,
                        componentIndex: c,
                    });
                });
            });

            return res;
        },
        mountEvents() {
            let eventManagerService = this.eventBus.getEventManager();
            eventManagerService.bindEvents(this.defaultBindEvents(), this);
        },
        onCheckChange: function () {
            if (this.selected) {
                this.selectedRows = [];
            } else {
                this.excludedRows = [];
            }

            let eventName = this.selected ? `${this.componentIndex()}:selectAll` : `${this.componentIndex()}:deselectAll`;
            this.eventBus.$emit(eventName);
            this.emitStateSelectedRow();
        },
        resetState() {
            this.selected = false;
            this.selectedRows = [];
            this.excludedRows = [];
        },
        rowDeselected(row, identityField) {
            if (this.selected) {
                this.addExcludedRow(row, identityField);

                return;
            }

            this.removeSelectedRow(row, identityField);
        },
        rowSelected(row, identityField) {
            if (this.selected) {
                this.removeExcludedRow(row, identityField);

                return;
            }

            this.addSelectedRow(row, identityField);
        },
        removeSelectedRow(row, identityField) {
            let searchValue = row[identityField];
            let index = this.selectedRows.findIndex(r => r[identityField] === searchValue);

            this.selectedRows.splice(index, 1);
            this.emitStateSelectedRow();
        },
        removeExcludedRow(row, identityField) {
            let searchValue = row[identityField];
            let index = this.excludedRows.findIndex(r => r[identityField] === searchValue);

            this.excludedRows.splice(index, 1);
            this.emitStateSelectedRow();
        },
        emitStateSelectedRow() {
            let data = {};
            data[`selected`] = this.selectedRows.map(s => s.id);
            data[`excluded`] = this.excludedRows.map(s => s.id);
            data[`allSelected`] = this.selected;
            this.eventBus.$store.commit('setState', {componentIndex: this.config['dataIndex'], data: data});

            this.eventBus.$emit(`${this.parentIndex}:setState`, data);
        }
    },
}
</script>



// WEBPACK FOOTER //
// SelectRowsComponent.vue?e639241c